import React, { useState, useContext, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import UseMoondanceApi from "../../../moondance/lib/api";
import withRouter from "../withRouter";
import { MoondanceContext } from '../../../App';

const ProfileMenu = props => {

  // Declare a new state variable, which we'll call "menu"

  const moondanceApi = UseMoondanceApi();
  const [menu, setMenu] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [username, setusername] = useState("User");
  const [showAdminMenu, setShowAdminMenu] = useState(false);

  const { darkMode, toggleDarkMode } = useContext(MoondanceContext);



  const actionsSidebar = [

    {
      label: "Actions",
      isMainMenu: true,
    },
    {
      label: "Add Transaction",
      icon: "mdi mdi-cash",
      isHasArrow: true,
      url: '/addTransaction'
    },
    {
      label: "Update NAV",
      icon: "mdi mdi-gold",
      isHasArrow: true,
      url: "/addNav",
    },

    {
      label: "Add Position",
      icon: "mdi mdi-bank-plus",
      isHasArrow: true,
      url: "/addPosition",
    },
    {
      label: "Group Nav Update",
      icon: "mdi mdi-gold",
      isHasArrow: true,
      url: '/navbulk'
    },
    {
      label: "Generate Report",
      icon: " mdi mdi-printer",
      url: "/report",
      isHasArrow: true,
    },
    {
      label: "Import your Data",
      icon: "mdi mdi-file-import",
      isHasArrow: true,
      url: "/importXls",
    },
    {
      label: "Export your Data",
      icon: "mdi mdi-file-excel",
      isHasArrow: true,
      url: "/export",
    },
    {
      label: "Add File",
      icon: "mdi mdi-file",
      isHasArrow: true,
      url: "/addFile",
    },






  ];

  useEffect(() => {
    const fetchUserProfile = async () => {
      const profile = await moondanceApi.getLoggedinUser();

      if (
        profile
        && profile.data
        && profile.data.first_name
        && profile.data.last_name) {
        setusername(profile.data.first_name + ' ' + profile.data.last_name);
      }
      if (
        profile
        && profile.data
        && profile.data.access_level
        && profile.data.access_level === 'admin') {
        setShowAdminMenu(true);
      }
    };
    fetchUserProfile();
  }, []);



  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="bx bxs-user" />
          <span className="d-none d-xl-inline-block ms-2 me-2">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end app-dark-dropdown">

          <DropdownItem
            onClick={(e) => { e.preventDefault(); toggleDarkMode(!darkMode); }}
            toggle={false}
          >
            <i className={(darkMode ? "mdi mdi-white-balance-sunny" : "mdi mdi-weather-night") + " align-middle me-2"} />
            {darkMode ? props.t("Light mode") : props.t("Dark mode")}
          </DropdownItem>
          <div className="dropdown-divider" />

          <DropdownItem tag="a" href="/userprofile">
            {" "}
            <i className="ri-user-line align-middle me-2" />
            {props.t("Your Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="/selectAccount">
            <i className="mdi mdi-account-group align-middle me-2" />
            {props.t("Select Account")}
          </DropdownItem>


          <DropdownItem tag="a" href="/accounts">
            <i className="mdi mdi-account-cog align-middle me-2" />
            {props.t("Accounts Settings")}
          </DropdownItem>
          <DropdownItem tag="a" href="/logs">
            <i className="mdi mdi-text-account align-middle me-2" />
            {props.t("Activity Logs")}
          </DropdownItem>


          {(showAdminMenu && (
            <>
              <div className="dropdown-divider" />
              <DropdownItem tag="a" href="/admin">
                <i className="mdi mdi-security align-middle me-2" />Admin Functions
              </DropdownItem>
            </>

          ))}

          <div className="dropdown-divider" />
          <Link to="/contact" className="dropdown-item">
            <i className="mdi mdi-face-agent align-middle me-2 " />
            <span>{props.t("Contact Us")}</span>
          </Link>
          <Link to="/logout" className="dropdown-item">
            <i className="mdi mdi-logout align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
